import api from "../../../utils/api"

interface IPhysicalPerson {
  email: string
  password: string
  typeLoginPf: number
  dnv: string
  numberCellPhone: string
  dddCellPhone: string
  cellPhone: string
  medicalRecordNumber: string
  firstAccessKey: string
}

const API_ROUTE = '/user/physical-person'

export const postPhysicalPerson = async (
  physicalPersonData: Partial<IPhysicalPerson>,
  tokenReCaptcha: string
) => {
  return await api.post(
    `${API_ROUTE}?tokenReCaptcha=${tokenReCaptcha}`,
    physicalPersonData
  )
}